<template>
  <tr class="payments-row">
    <td class="center-align" :inert="menu || inertProp">
      <span
        class="payments-row__detail-link"
        @click="$emit('openDialog')"
        tabindex="0"
        @keypress.enter="$emit('openDialog')"
        >{{ item.int_id }}</span
      >
    </td>
    <td class="center-align">
      {{ item.created_at ? dateFormatted(item.created_at, "MM/DD/YYYY") : "" }}
    </td>
    <td class="td-amount">{{ item.total_amount | currency }}</td>
    <td v-if="completedPayments">
      {{ item.paid_at ? dateFormatted(item.paid_at, "MM/DD/YYYY") : "" }}
    </td>
    <td class="center-align" :inert="menu || inertProp">
      <router-link
        :to="`/project/${project.id}/members`"
        v-for="project in uniqProjects(item)"
        :key="project.id"
      >
        {{ project.code }}
      </router-link>
    </td>
    <td class="center-align" :inert="menu || inertProp">
      <router-link
        :to="
          gig.hire_request_monday_com_item_id
            ? `/hire-requests/${gig.hire_request_monday_com_item_id}`
            : `/gig/${gig.id}`
        "
        v-for="gig in uniqGigs(item)"
        :key="gig.id"
      >
        {{ gig.title }}
      </router-link>
    </td>
    <td
      class="invoice__status center-align"
      :class="`invoice__status--${item.status}`"
    >
      {{ statuses[item.status] }}
    </td>
    <td>
      <div class="td-creator">
        <TableRowAvatar
          :user="item.user"
          :path="`/p/${item.user.username || item.user.id}/payments`"
          :inert="menu || inertProp"
        />
        <ActionsMenu
          class="payments-row__actions-toggle"
          v-if="currentUser.is_hiring_manager"
          @close="menu = false"
          @toggle="menu = !menu"
          :menu="menu"
          :themeDisabledPage="themeDisabledPage"
          :inertProp="menu || inertProp"
        >
          <v-btn
            @click="$emit('openDialog')"
            color="#262729"
            elevation="0"
            dark
          >
            View Invoice
          </v-btn>
          <v-btn @click="download(item)" color="#56565A" elevation="0" dark>
            Download PDF
          </v-btn>
          <v-btn
            @click="$emit('openCancelDialog')"
            color="#E12D1B"
            elevation="0"
            dark
            v-if="item.status != 'canceled'"
          >
            Cancel Invoice
          </v-btn>
          <v-btn
            @click="$emit('openPayDirectlyDialog')"
            color="#E12D1B"
            elevation="0"
            dark
          >
            Pay Directly
          </v-btn>
          <v-btn
            @click="$emit('openAuditDialog')"
            color="#262729"
            elevation="0"
            dark
          >
            View Audit Trail
          </v-btn>
        </ActionsMenu>
      </div>
    </td>
  </tr>
</template>

<script>
import themeDisabledPageMixin from "@/mixins/theme-disabled-page.mixin";
import paymentsTableFormats from "@/mixins/payments-table-formats.mixin";
import TableRowAvatar from "@/components/work-assignments/TableRowAvatar.vue";
import bottomMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-bottom.mixin.js";

export default {
  mixins: [
    themeDisabledPageMixin,
    paymentsTableFormats,
    bottomMenuEventBubbler,
  ],
  components: { TableRowAvatar },
  props: {
    item: Object,
    completedPayments: Boolean,
  },
  data() {
    return {
      statuses: {
        submitted: "Submitted",
        hm_approved: "HM Approved", // DEPRECATED
        hm_rejected: "HM Rejected", // DEPRECATED
        fi_approved: "Approved", // DEPRECATED
        fi_rejected: "Finance Rejected", // DEPRECATED
        paid: "Completed",
        canceled: "Canceled",
        processing: "Processing",
      },
    };
  },
  methods: {
    refresh() {
      this.menu = false;
      this.$emit("refresh");
    },
    download({ id }) {
      this.$api.Invoice.download({ id, concur: true });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/payments/payments-row.scss";
</style>
